import type {Preferences} from './preferences';

/** Phaser 3 uses CSS-pixel-sized WebGL buffers by default. Cap the extra pixels on phones. */
export function renderPixelRatio(
  devicePixelRatio: number,
  quality: Preferences['quality'],
  cssWidth: number,
  cssHeight: number,
  maxPixels = 4_000_000,
): number {
  if (![devicePixelRatio, cssWidth, cssHeight, maxPixels].every(Number.isFinite) || cssWidth <= 0 || cssHeight <= 0 || maxPixels <= 0) return 1;
  const qualityLimit = quality === 'high' ? 2 : quality === 'medium' ? 1.5 : 1;
  return Math.max(1, Math.min(devicePixelRatio, qualityLimit, Math.sqrt(maxPixels / (cssWidth * cssHeight))));
}

